import { React } from "react";
import { ReactComponent as ProfileLogo } from "../assets/avataaars.svg";
import { FaFileDownload, FaEnvelope } from "react-icons/fa";

const Home = () => {
  return (
    <main className="flex h-full w-2/3 grow flex-col items-center justify-around pb-9">
      <h1 className="py-5 text-4xl text-light-primary-1 dark:text-dark-primary-2">
        Hi! {`👋`}
      </h1>
      <p className="py-5 text-center font-google-roboto text-2xl font-semibold leading-snug text-light-primary-2 dark:text-dark-primary-2">
        I am a Data / Backend Engineer with 6 years of experience in designing
        highly scalable, available, distributed systems. I am passionate about
        problem solving, system design and data management. Thank you for your
        interest in my profile, looking forward to connect with you!
      </p>
      <div class="flex w-2/3 max-w-screen-md flex-row items-center justify-evenly">
        <a
          href="mailto:gautham18113@gmail.com"
          className="ml-3 mr-3 flex h-14 w-36 flex-row items-center justify-evenly rounded-lg bg-light-primary-1 text-2xl text-light-secondary-1 dark:bg-dark-primary-1 dark:text-dark-primary-2"
        >
          Email <FaEnvelope />
        </a>
        <a
          className="ml-3 mr-3 flex h-14 w-36 flex-row items-center justify-evenly rounded-lg bg-light-primary-1 text-2xl text-light-secondary-1 dark:bg-dark-primary-1 dark:text-dark-primary-2"
          href="https://www.icloud.com/iclouddrive/089r3vJJet8zJECS0QjUWsvfg#20221228_Resume"
        >
          Resume <FaFileDownload />
        </a>
      </div>
      <ProfileLogo className="py-5" />
    </main>
  );
};

export default Home;
